import {CadastroAche} from "./modules/cadastros/containers/Ache";
import {CadastroETT} from "./modules/cadastros/containers/ETT";
import {CadastroGDV} from "./modules/cadastros/containers/GDV";
import {CadastroGrupoNGFT} from "./modules/cadastros/containers/GrupoNGFT";
import {CadastroJustificativaContratacao} from "./modules/cadastros/containers/JustificativaContratacao";
import {CadastroMotivoGeral} from "./modules/cadastros/containers/MotivoGeral";
import {CadastroUsuario} from "./modules/cadastros/containers/Usuario";
import {CadastroProduto} from "./modules/cadastros/containers/Produto";
import {Login} from "./modules/login/containers/Login";
import {ParametrosGerais} from "./modules/administracao/containers/ParametrosGerais";
import {SolicitacoesPendentes} from "./modules/pendentes/containers/SolicitacoesPendentes";
import {HorasExtrasPendentes} from "./modules/pendentes/containers/HorasExtrasPendentes";
import {SolicitacaoContratacao} from "./modules/solicitacao/containers/SolicitacaoContratacao";
import {DetalhesSolicitacao} from "./modules/fluxos/solicitacao_contratacao/containers/DetalhesSolicitacao";
import {Rascunhos} from "./modules/controle/containers/Rascunhos";
import {ContratacoesVigentes} from "./modules/controle/containers/ContratacoesVigentes";
import {ContratacoesConcluidas} from "./modules/controle/containers/ContratacoesConcluidas";
import {LotesPagamento} from "./modules/controle/containers/LotesPagamento";
import {SolicitacoesAndamento} from "./modules/controle/containers/SolicitacoesAndamento";
import {DelegacaoTarefas} from "./modules/preferencias/containers/DelegacaoTarefas";
import {SolicitacaoTA} from "./modules/fluxos/solicitacao_termino_antecipado/containers/SolicitacaoTA";
import {SolicitacaoSubstituicao} from "./modules/fluxos/solicitacao_substituicao/containers/SolicitacaoSubstituicao";
import {SolicitacaoMigracao} from "./modules/fluxos/solicitacao_migracao/containers/SolicitacaoMigracao";
import {SolicitacaoProrrogacao} from "./modules/fluxos/solicitacao_prorrogacao/containers/SolicitacaoProrrogacao";
import {PainelDelegacao} from "./modules/administracao/containers/PainelDelegacao";
import {AtualizacaoGestorSolicitante} from "./modules/administracao/containers/AtualizacaoGestorSolicitante"; //RHFPP-612 - Gestor Solicitante
import {HistoricoContratacao} from "./modules/controle/containers/HistoricoContratacao";
import {HorasTrabalhadasPendentes} from "./modules/pendentes/containers/HorasTrabalhadasPendentes";
import { LotesPagamentoRelatorio } from "./modules/relatorios/containers/LotesPagamentoRelatorio";

import {
    VisaoGeralSolicitacoes,
    QuantidadePercentualSolicitacaoJustificativa,
    QuantidadePercentualMOTsFaixaRemuneracao,
    QuantidadePercentualSolicitacaoExcecaoDivisaoDepartamento,
    SolicitacaoDentroForaPrazo,
    QuantidadePercentualSolicitacaoForaPrazoDivisaoDepartamento,
    CargosMaisContratados10,
    SolicitacaoMensalDivisao,
    QuantidadePercentualContratacaoProduto,
    ClassificacaoMediaAlocacao,
    MediaHorasExtrasMOTA,
    MediaHorasExtrasMOTB,
    MediaHorasExtrasMOTC,
    SomatorioHorasExtrasMOTA,
    SomatorioHorasExtrasMOTB,
    SomatorioHorasExtrasMOTC,
    MediaDuracaoContratoMOT,
    QuantidadeMOTFornecedor,
    QuantidadePercentualMigracaoProduto,
    ProrrogacaoMOTRealizada,
    TempoMedioPreenchimentoVaga,
    TempoMedioRespostaPool,
    SolicitacaoNaoAtendidaFornecedor
} from "./modules/indicadores/containers";
import {
    Solicitacao,
    AuditoriaSubstituicao,
    AuditoriaAcessoCrachaLiberacaoPeriodoMOT,
    AuditoriaAlocacaoMOT,
    Financeiro,
    TimesheetsPendentes
} from "./modules/relatorios/containers";
import {DetalhesSolicitacaoSubstituicao} from "./modules/fluxos/solicitacao_substituicao/containers/DetalhesSolicitacaoSubstituicao";
import {DetalhesSolicitacaoETT} from "./modules/fluxos/solicitacao_ett/containers/DetalhesSolicitacaoETT";
import {DetalhesSolicitacaoTA} from "./modules/fluxos/solicitacao_termino_antecipado/containers/DetalhesSolicitacaoTA";
import {DetalhesSolicitacaoProrrogacao} from "./modules/fluxos/solicitacao_prorrogacao/containers/DetalhesSolicitacaoProrrogacao";
import { EnvioHorasExtras } from "./modules/fluxos/timesheet/containers/EnvioHorasExtras";
import {DetalhesHorasExtras} from "./modules/fluxos/timesheet/containers/DetalhesHorasExtras";
import {PagamentosPendentes} from "./modules/pendentes/containers/PagamentosPendentes";
import {EnvioPagamento} from "./modules/fluxos/pagamento/containers/EnvioPagamento";
import {DetalhesLotePagamento} from "./modules/pagamento/containers/DetalhesLotePagamento";
import {DetalhesAndamentoProrrogacao} from "./modules/fluxos/solicitacao_prorrogacao/containers/DetalhesAndamentoProrrogacao";
import {DetalhesAndamentoSubstituicao} from "./modules/fluxos/solicitacao_substituicao/containers/DetalhesAndamentoSubstituicao";
import {DetalhesAndamentoTA} from "./modules/fluxos/solicitacao_termino_antecipado/containers/DetalhesAndamentoTA";
import {SolicitacaoRetroativa} from "./modules/administracao/containers/SolicitacaoRetroativa";
import {MotsAtivas} from "./modules/relatorios/containers/MotsAtivas";
import {SisMot} from "./modules/relatorios/containers/SisMot";
import {CadastroEmpresaGlobo} from "./modules/cadastros/containers/EmpresaGlobo";
import {CadastroLotacao} from "./modules/cadastros/containers/Lotacao";
import {PisoSalarial} from "./modules/cadastros/containers/PisoSalarial";
import {Timesheets} from "./modules/fluxos/timesheet/containers/Timesheets";

import { TimesheetsNaoGerados } from "./modules/pendentes/containers/TimesheetsNaoGerados";
import { CalculoCustoMot } from "./modules/controle/containers/CalculoCustoMot";

import {EnvioHorasTrabalhadas} from "./modules/fluxos/timesheet/containers/EnvioHorasTrabalhadas";
import {DetalhesHorasTrabalhadas} from "./modules/fluxos/timesheet/containers/DetalhesHorasTrabalhadas";
import {DetalhesTarefaProrrogacao} from "./modules/fluxos/solicitacao_prorrogacao/containers/DetalhesTarefaProrrogacao";
import { DetalhesSolicitacaoContratacao } from "./modules/fluxos/solicitacao_contratacao/containers/DetalhesSolicitacaoContratacao";
import { MotsPorSindicato } from "./modules/relatorios/containers/MotsPorSindicato";

class Routes {
    constructor() {
        this.data = [
            {
                "separator": true,
                "label": "Ações pendentes",
                "icon": "envelope",
                "itens": [
                    {
                        "label": "Solicitações",
                        "path": "/solicitacoes-pendentes",
                        "component": SolicitacoesPendentes,
                        "onSideBar": true,
                        "icon": "envelope"
                        //"listCount": 1 //TODO
                    },{
                        "label": "Timesheets não gerados",
                        "path": "/timesheets-nao-gerados",
                        "component": TimesheetsNaoGerados,
                        "onSideBar": true,
                        "icon": "calendar-times-o",
                        "permission": ["administrador"]
                    }/*,{
                        "label": "Horas trabalhadas",
                        "path": "/horas-trabalhadas-pendentes",
                        "component": HorasExtrasPendentes,
                        "onSideBar": true,
                        "icon": "envelope",
                        "permission": ["administrador"]
                        //"listCount": 1 //TODO
                    }*/,{
                        "label": "Horas trabalhadas",
                        "path": "/horas-trabalhadas-pendentes-v2",
                        "component": HorasTrabalhadasPendentes,
                        "onSideBar": true,
                        "icon": "envelope"
                        //"listCount": 1 //TODO
                    },{
                        "label": "Pagamentos",
                        "path": "/pagamentos-pendentes",
                        "component": PagamentosPendentes,
                        "onSideBar": true,
                        "permission": "ett",
                        "icon": "envelope"
                        //"listCount": 1 //TODO
                    },
                    {/*TODO: separar para área que não aparece no sidebar*/
                        "path": "/login",
                        "component":  Login
                    },{
                        "path": "/",
                        "component":  Login
                    },{
                        "path": "/nova-solicitacao-contratacao",
                        "component": SolicitacaoContratacao
                    },{
                        "path": "/nova-solicitacao-contratacao/:id",
                        "component": SolicitacaoContratacao
                    },{
                        "path": "/clonar-solicitacao-contratacao/:id",
                        "component": SolicitacaoContratacao
                    },{
                        "path": "/ajuste-solicitacao/:id",
                        "component": SolicitacaoContratacao
                    },{
                        "path": "/envio-pagamento/:id",
                        "component": EnvioPagamento
                    },{
                        "path": "/detalhamento-horas-trabalhadas/tarefa/:taskIdBpm",
                        "component": DetalhesHorasExtras
                    },{
                        "path": "/ajuste-horas-trabalhadas/tarefa/:taskIdBpm",
                        "component": EnvioHorasExtras
                    },{
                        "path": "/envio-horas-trabalhadas/tarefa/:taskIdBpm",
                        "component": EnvioHorasExtras
                    },{
                        "path": "/detalhamento/tarefa/:taskIdBpm",
                        "component": DetalhesSolicitacao
                    },{
                        "path": "/detalhamento-substituicao/tarefa/:taskIdBpm",
                        "component": DetalhesSolicitacaoSubstituicao
                    },{
                        "path": "/detalhamento-termino-antecipado/tarefa/:taskIdBpm",
                        "component": DetalhesSolicitacaoTA
                    },{
                        "path": "/detalhamento-prorrogacao/tarefa/:taskIdBpm",
                        "component": DetalhesSolicitacaoProrrogacao
                    },{
                        "path": "/detalhamento-solicitacao-ett/tarefa/:taskIdBpm",
                        "component": DetalhesSolicitacaoETT
                    },{
                        "path": "/solicitacao-termino-antecipado/:solicitacaoId/:solicitacaoEttId",
                        "component": SolicitacaoTA
                    },{
                        "path": "/solicitacao-termino-antecipado/:solicitacaoId/:solicitacaoEttId/:taskIdBpmSubstituicao/:substituicaoId",
                        "component": SolicitacaoTA
                    },{
                        "path": "/solicitacao-substituicao/:solicitacaoId/:solicitacaoEttId",
                        "component": SolicitacaoSubstituicao
                    },{
                        "path": "/solicitacao-migracao/:solicitacaoId/:solicitacaoEttId",
                        "component": SolicitacaoMigracao
                    },{
                        "path": "/solicitacao-prorrogacao/:solicitacaoId/:solicitacaoEttId",
                        "component": SolicitacaoProrrogacao
                    },{
                        "path": "/ajuste-prorrogacao/:taskIdBpm",
                        "component": SolicitacaoProrrogacao
                    },{
                        "path": "/detalhamento/substituicao/:solicitacaoId/:solicitacaoEttId/:substituicaoId",
                        "component": DetalhesAndamentoSubstituicao
                    },{
                        "path": "/detalhamento/prorrogacao/:solicitacaoId/:solicitacaoEttId/:prorrogacaoId",
                        "component": DetalhesAndamentoProrrogacao
                    },{
                        "path": "/detalhamento/termino-antecipado/:solicitacaoId/:solicitacaoEttId/:terminoAntecipadoId",
                        "component": DetalhesAndamentoTA
                    },{
                        "path": "/detalhamento/solicitacao/:solicitacaoId/:solicitacaoEttId",
                        "component": DetalhesSolicitacao
                    },{
                        "path": "/detalhamento/solicitacao/:solicitacaoId",
                        "component": DetalhesSolicitacao
                    },{
                        "path": "/timesheet/:idTimesheet",
                        "component": EnvioHorasExtras
                    },{
                        "path": "/detalhes-lote-pagamento/:idLote",
                        "component": DetalhesLotePagamento
                    },{
                        "path": "/detalhes-lote-pagamento/timesheet/:timesheetId",
                        "component": DetalhesHorasExtras
                    },{/* RHFPP-2370 POC TIMESHEET */
                        "path": "/detalhamento-horas-trabalhadas/v2/tarefa/:taskIdBpm",
                        "component": DetalhesHorasTrabalhadas
                    },{
                        "path": "/ajuste-horas-trabalhadas/v2/tarefa/:taskIdBpm",
                        "component": EnvioHorasTrabalhadas
                    },{
                        "path": "/envio-horas-trabalhadas/v2/tarefa/:taskIdBpm",
                        "component": EnvioHorasTrabalhadas
                    },{
                        "path": "/prorrogacao-contrato/tarefa/:taskIdBpm",
                        "component": DetalhesTarefaProrrogacao
                    },{
                        "path": "/solicitacao-contrato/tarefa/:taskIdBpm",
                        "component": DetalhesSolicitacao
                    },{
                        "path": "/ajuste-solicitacao-contrato/:id",
                        "component": SolicitacaoContratacao
                    },{
                        "path": "/contratacao/tarefa/:taskIdBpm",
                        "component": DetalhesSolicitacaoETT
                    }
                ]
            },{
                "separator": true,
                "label": "Controle",
                "icon": "calendar-check-o",
                //"permission": "possui-perfil",// removido pois NGFT e Aprovador Extra não possuem perfil
                "itens": [
                    {
                        "label": "Rascunhos",
                        "path": "/rascunhos",
                        "component": Rascunhos,
                        "onSideBar": true,
                        "icon": "file",
                        "permission": "solicitar-mot"
                    },{
                        "label": "Solicitações em andamento",
                        "path": "/solicitacao-andamento",
                        "component":  SolicitacoesAndamento,
                        "onSideBar": true,
                        "icon": "calendar-check-o"
                        /*"permission": "possui-perfil"*/
                    },{
                        "label": "Contratações vigentes",
                        "path": "/contratacoes-vigentes",
                        "component":  ContratacoesVigentes,
                        "onSideBar": true,
                        "icon": "calendar-check-o",
                        //"permission": "possui-perfil" // removido pois NGFT e Aprovador Extra não possuem perfil
                    },{
                        "label": "Contratações concluídas",
                        "path": "/contratacoes-concluidas",
                        "component": ContratacoesConcluidas,
                        "onSideBar": true,
                        "icon": "calendar-times-o",
                        // "permission": "possui-perfil" // removido pois NGFT e Aprovador Extra não possuem perfil
                    },{
                        "label": "Lotes de pagamento",
                        "path": "/lotes-pagamento",
                        "component": LotesPagamento,
                        "onSideBar": true,
                        "icon": "calendar-times-o",
                        "permission": "administrador-ou-ett" // removido pois NGFT e Aprovador Extra não possuem perfil
                    },{
                         "label": "Timesheets",
                         "path": "/timesheets",
                         "component": Timesheets,
                         "onSideBar": true,
                         "icon": "calendar-times-o",
                         "permission": ["administrador-ou-gestor"] // removido pois NGFT e Aprovador Extra não possuem perfil
                     },{
                        //RHFPP-1548 - Consulta Custo de Mot 
                        "label": "Cálculo de custo para contratação de MOT",
                        "path": "/calculo-custo-mot",
                        "component": CalculoCustoMot,
                        "onSideBar": true,
                        "icon": "calendar-times-o",
                        "permission": ["administrador-ou-gestor"] 
                    },{
                        "label": "Histórico de contratos e simulação de quarentena",
                        "path": "/historico-contratacao",
                        "component": HistoricoContratacao,
                        "onSideBar": true,
                        "icon": "calendar-times-o",
                        "permission": ["administrador-ou-gestor", "ett"] 
                    }
                ]
            },{
                "separator": true,
                "label": "Cadastros",
                "permission": "administrador",
                "icon": "tag",
                "itens":[
                    {
                        "label": "Ache",
                        "path": "/cadastro-ache",
                        "component":  CadastroAche,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "ETT",
                        "path": "/cadastro-ett",
                        "component":  CadastroETT,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "GDV",
                        "path": "/cadastro-gdv",
                        "component":  CadastroGDV,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Grupo NGFT",
                        "path": "/cadastro-grupo-ngft",
                        "component":  CadastroGrupoNGFT,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Justificativa para contratação",
                        "path": "/cadastro-justificativa-contratacao",
                        "component":  CadastroJustificativaContratacao,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Motivo geral",
                        "path": "/cadastro-motivo-geral",
                        "component":  CadastroMotivoGeral,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Usuário",
                        "path": "/cadastro-perfil-usuario",
                        "component":  CadastroUsuario,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Projeto/centro de resultado/finalidade",
                        "path": "/cadastro-produto",
                        "component":  CadastroProduto,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Unidade de negócio (BU)",
                        "path": "/cadastro-bu",
                        "component":  CadastroEmpresaGlobo,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Lotação",
                        "path": "/cadastro-lotacao",
                        "component":  CadastroLotacao,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Piso Salarial",
                        "path": "/cadastro-piso-salarial",
                        "component":  PisoSalarial,
                        "onSideBar": true,
                        "icon": "tag"
                    }
                ]
	        },{
                "separator": true,
                "label": "Indicadores",
                "permission": ["administrador","rts","remuneracao"],
                "icon": "bar-chart",
                "itens": [
                    {
                        "label": "Visão geral das solicitações",
                        "path": "/indicador-visao-geral-solicitacoes",
                        "component":  VisaoGeralSolicitacoes,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Quantidade e percentual solicitação por justificativa",
                        "path": "/indicador-quantidade-percentual-solicitacao-justificativa",
                        "component":  QuantidadePercentualSolicitacaoJustificativa,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Quantidade e percentual de MOTs por faixa de remuneração",
                        "path": "/indicador-quantidade-percentual-mots-faixa-remuneracao",
                        "component":  QuantidadePercentualMOTsFaixaRemuneracao,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Quantidade e percentual de solicitações exceção por divisão e departamento",
                        "path": "/indicador-quantidade-percentual-solicitacao-excecao-divisao-departamento",
                        "component":  QuantidadePercentualSolicitacaoExcecaoDivisaoDepartamento,
                        "onSideBar": true,
                        "icon": "tag"
                    }/*,{
                        "label": "Solicitações dentro e fora do prazo",
                        "path": "/indicador-solicitacao-dentro-fora-prazo",
                        "component":  SolicitacaoDentroForaPrazo,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Quantidade e percentual de solicitações fora do prazo por divisão e departamento",
                        "path": "/indicador-quantidade-percentual-solicitacao-fora-prazo-divisao-departamento",
                        "component":  QuantidadePercentualSolicitacaoForaPrazoDivisaoDepartamento,
                        "onSideBar": true,
                        "icon": "tag"
                    }*/,{
                        "label": "Os 10 cargos mais contratados",
                        "path": "/indicador-cargos-mais-contratatos-10",
                        "component":  CargosMaisContratados10,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Solicitações mensais por divisão",
                        "path": "/indicador-solicitacao-mensal-divisao",
                        "component":  SolicitacaoMensalDivisao,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Quantidade e percentual de contratações por projeto/centro de resultado/finalidade",
                        "path": "/indicador-quantidade-percentual-contratacao-produto",
                        "component":  QuantidadePercentualContratacaoProduto,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Classificação de cargos pela média de alocação",
                        "path": "/indicador-classificacao-media-alocacao",
                        "component": ClassificacaoMediaAlocacao,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Média de horas extras da MOT por cargo",
                        "path": "/indicador-media-horas-extras-mot-a",
                        "component": MediaHorasExtrasMOTA,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Média de horas extras da MOT por projeto/centro de resultado/finalidade",
                        "path": "/indicador-media-horas-extras-mot-b",
                        "component": MediaHorasExtrasMOTB,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Média de horas extras da MOT por Unidade de negócio (BU)",
                        "path": "/indicador-media-horas-extras-mot-c",
                        "component": MediaHorasExtrasMOTC,
                        "onSideBar": true,
                        "icon": "tag"
                    }/*,{
                        "label": "Somatório de horas extras da MOT por cargo",
                        "path": "/indicador-somatorio-horas-extras-mot-a",
                        "component": SomatorioHorasExtrasMOTA,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Somatório de horas extras da MOT produto",
                        "path": "/indicador-somatorio-horas-extras-mot-b",
                        "component": SomatorioHorasExtrasMOTB,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Somatório de horas extras da MOT por Unidade de negócio (BU)",
                        "path": "/indicador-somatorio-horas-extras-mot-c",
                        "component": SomatorioHorasExtrasMOTC,
                        "onSideBar": true,
                        "icon": "tag"
                    }*/,{
                        "label": "Média de duração de contrato da MOT",
                        "path": "/indicador-media-duracao-contrato-mot",
                        "component":  MediaDuracaoContratoMOT,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Quantidade de MOT por fornecedor (ETT)",
                        "path": "/indicador-quantidade-mot-fornecedor",
                        "component":  QuantidadeMOTFornecedor,
                        "onSideBar": true,
                        "icon": "tag"
                    }/*,{
                        "label": "Quantidade e percentual de migrações entre produtos",
                        "path": "/indicador-quantidade-percentual-migracao-produto",
                        "component": QuantidadePercentualMigracaoProduto,
                        "onSideBar": true,
                        "icon": "tag"
                    }*/,{
                        "label": "Prorrogações de MOT realizadas",
                        "path": "/indicador-prorrogacao-mot-realizada",
                        "component": ProrrogacaoMOTRealizada,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Tempo médio de preenchimento das vagas",
                        "path": "/indicador-tempo-medio-preenchimento-vaga",
                        "component": TempoMedioPreenchimentoVaga,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Tempo médio de resposta no pool",
                        "path": "/indicador-tempo-medio-resposta-pool",
                        "component": TempoMedioRespostaPool,
                        "onSideBar": true,
                        "icon": "tag"
                    },{
                        "label": "Solicitações não atendidas por fornecedor (ETT)",
                        "path": "/indicador-solicitacao-nao-atendida-fornecedor",
                        "component": SolicitacaoNaoAtendidaFornecedor,
                        "onSideBar": true,
                        "icon": "tag"
                    }
                ]
	        },{
                "separator": true,
                "label": "Relatórios",
                "permission": ["administrador","rts","remuneracao", "administrador-ou-gestor-ou-permitido", "administrador-ou-relatorio-sis-mot", "ett"],
                "icon": "file-text-o",
                "itens": [
                    {
                        "label": "Solicitações",
                        "path": "/relatorio-solicitacao",
                        "component": Solicitacao,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador","rts","remuneracao"],
                    }, {
                        "label": "Auditoria substituições",
                        "path": "/relatorio-auditoria-substituicao",
                        "component": AuditoriaSubstituicao,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador","rts","remuneracao"],
                    }, {
                        "label": "Auditoria acessos, crachás e liberações pós período MOT",
                        "path": "/relatorio-auditoria-acesso-cracha-liberacao-periodo-mot",
                        "component": AuditoriaAcessoCrachaLiberacaoPeriodoMOT,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador","rts","remuneracao"],
                    }, {
                        "label": "Auditoria alocação de MOTs",
                        "path": "/relatorio-auditoria-alocacao-mot",
                        "component": AuditoriaAlocacaoMOT,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador","rts","remuneracao"],
                    }, {
                        "label": "Financeiro",
                        "path": "/relatorio-financeiro",
                        "component": Financeiro,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador-ou-gestor-ou-relatorio-financeiro"]
                    }, {
                        "label": "Lotes de pagamento",
                        "path": "/relatorio-lotes-pagamento",
                        "component": LotesPagamentoRelatorio,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador", "gestor"]
                    }, {
                        "label": "Timesheets pendentes",
                        "path": "/relatorio-timesheets-pendentes",
                        "component": TimesheetsPendentes,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador-ou-gestor-ou-relatorio-timesheet", "ett"]
                    }, {
                        "label": "MOTs ativas",
                        "path": "/relatorio-mots-ativas",
                        "component": MotsAtivas,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador-ou-relatorio-mots-ativas"]
                    }, 
                    {
                        "label": "MOTs para Seguro",
                        "path": "/relatorio-sis-mot",
                        "component": SisMot,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador-ou-relatorio-sis-mot"]
                    }, 
                    {
                        "label": "MOTs por Sindicato",
                        "path": "/relatorio-mots-por-sindicato",
                        "component": MotsPorSindicato,
                        "onSideBar": true,
                        "icon": "tag",
                        "permission": ["administrador", "ett"]
                    }
                ]
            },{
                "separator": true,
                "label": "Administração",
                "permission": "administrador",
                "icon": "cog",
                "itens":[
                    {
                        "label": "Parâmetros do sistema",
                        "path": "/parametros-gerais",
                        "component":  ParametrosGerais,
                        "onSideBar": true,
                        "icon": "cog"
                    },
                    {
                        "label": "Painel de delegações",
                        "path": "/delegacoes",
                        "component":  PainelDelegacao,
                        "onSideBar": true,
                        "icon": "cog"
                    },{
                        "label": "Solicitação retroativa",
                        "path": "/solicitacao-retroativa",
                        "component":  SolicitacaoRetroativa,
                        "onSideBar": true,
                        "icon": "cog"
                    },
                    //RHFPP-612 - Tela p/ atualizar gestor solicitante
                    {
                        "label": "Atualizar Gestor Solicitante",
                        "path": "/atualiza-gestor-solicitante",
                        "component":  AtualizacaoGestorSolicitante,
                        "onSideBar": true,
                        "icon": "user"
                    }
                ]
            },{
                "separator": true,
                "label": "Preferências",
                "permission": "nao-ett",
                "icon": "user",
                "itens":[
                    {
                        "label": "Delegação de tarefas",
                        "path": "/delegacao-tarefas",
                        "component":  DelegacaoTarefas,
                        "onSideBar": true,
                        "icon": "mail-forward"
                    }
                ]
            }];
    }
}

export default Routes;
